"use client";
import useSWR from "swr";
import { getBoxesCount, getRecentPlays } from "../api/play";

export function useBoxesCount(userId?: string) {
  const { data, error, mutate, isLoading } = useSWR(
    userId ? [`boxesCount`, userId] : null,
    () => getBoxesCount(userId),
    {
      refreshInterval: 60_000, // revalidate every 1 min
      dedupingInterval: 30_000,
      shouldRetryOnError: false,
    }
  );

  return {
    boxCounts: data?.boxCounts ?? {},
    resetsAt: data?.resetsAt ?? null,
    loading: isLoading,
    error,
    refetch: mutate,
  };
}

export function useRecentPlays() {
  const { data, error, isLoading, mutate } = useSWR(
    "recentPlays",
    getRecentPlays,
    {
      refreshInterval: 15_000, // refresh every 15 s for a “live” feel
      dedupingInterval: 7_000,
      shouldRetryOnError: false,
    }
  );

  return {
    plays: data?.plays ?? [],
    loading: isLoading,
    error,
    refetch: mutate,
  };
}
